import {
    createPromoPriceComponent,
    PromoPrice,
} from '@vfde-brix/promo-price';

/**
 * Promo Price component
 * @param container
 */
const mountPromoPrice = (container: HTMLElement): PromoPrice => {
    return createPromoPriceComponent(container, {});
};

export default mountPromoPrice;
